/**
 * Light and dark, both first-class.
 *
 * The choice is written to `data-theme` on the document element and to
 * `localStorage`; `index.html` reads it back before first paint so a reload does
 * not flash white at an officer working in a dark room at seven in the morning.
 */

export type Theme = 'light' | 'dark'

const KEY = 'aweil-theme'

export function currentTheme(): Theme {
  const attr = document.documentElement.getAttribute('data-theme')
  return attr === 'dark' ? 'dark' : 'light'
}

export function setTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme)
  try {
    localStorage.setItem(KEY, theme)
  } catch {
    // A locked-down browser profile is not a reason to fail to switch themes.
  }
}
